import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSliderModule } from '@angular/material/slider';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NouisliderModule } from 'ng2-nouislider';
import { Ng5SliderModule } from 'ng5-slider';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgProgressModule } from "ngx-progressbar";
import { NgProgressHttpModule } from "ngx-progressbar/http";
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { CoreModule } from '../../core/core.module';
import { SharedModule } from '../../shared/shared.module';
import { AuthModule } from '../auth/auth.module';
import { ReviewFareSummaryComponent } from './booking/components/review-fare-summary/review-fare-summary.component';
import { GuestDetailsComponent } from './booking/guest-details/guest-details.component';
import { BookingComponent, BookingConfirmComponent, BookingFareSummaryComponent, BookingFlightDetailComponent, ConfirmPassengerComponent, ServiceRequestsComponent } from './booking/index';
import { PaymentDetailsComponent } from './booking/payment-details/payment-details.component';
import { VoucherComponent } from './booking/voucher/voucher.component';
import {
  BookingStepsComponent, FlightCityListComponent, FormExtensionComponent, MulticityComponent,
  OnewayComponent,
  RoundtripComponent
} from './components/index';
import { PreferredAirlineComponent } from './components/preferred-airline/preferred-airline.component';
import { FlightsRoutingModule } from './flights-routing.module';
import { FlightsComponent } from './flights.component';
import { FlightDetailsBaggageComponent } from './result/flight-details/flight-details-baggage/flight-details-baggage.component';
import { FlightDetailsFareComponent } from './result/flight-details/flight-details-fare/flight-details-fare.component';
import { FlightDetailsItineraryComponent } from './result/flight-details/flight-details-itinerary/flight-details-itinerary.component';
import { SendItineraryComponent } from './result/flight-details/send-itinerary/send-itinerary.component';
import { TripInfoComponent } from './result/flight-details/trip-info/trip-info.component';
import {
  AirlineCarouselComponent, AirlineFeaturesComponent, AirlinesFilterComponent,
  AirportsNearbyFilterComponent, ArrivalTimeFilterComponent, DepartureTimeFilterComponent, FiltersComponent,
  FlightDetailsComponent, PreferencesFilterComponent, PriceFilterComponent, ResultComponent, SortingComponent,
  StopoverCityFilterComponent, StopsFilterComponent
} from './result/index';
import { MobileVoucherComponent } from './booking/mobile-voucher/mobile-voucher.component';
import { NgxLoadingModule } from 'ngx-loading';
import { FareFamiliesFilterComponent } from './result/filters/fare-families-filter/fare-families-filter.component';
import { DepartureFromFilterComponent } from './result/filters/departure-from-filter/departure-from-filter.component';
import { ArrivalToFilterComponent } from './result/filters/arrival-to-filter/arrival-to-filter.component';
import { FareTypeFilterComponent } from './result/filters/fare-type-filter/fare-type-filter.component';
import { CabinClassFilterComponent } from './result/filters/cabin-class-filter/cabin-class-filter.component';
import { PaymentStatusComponent } from './booking/payment-details/payment-status/payment-status.component';

@NgModule({
  declarations: [
    FlightsComponent,
    MulticityComponent,
    OnewayComponent,
    RoundtripComponent,
    FlightCityListComponent,
    BookingStepsComponent,
    FormExtensionComponent,
    AirlineFeaturesComponent,
    SortingComponent,
    AirlineCarouselComponent,
    ResultComponent,
    FiltersComponent,
    PriceFilterComponent,
    StopsFilterComponent,
    DepartureTimeFilterComponent,
    ArrivalTimeFilterComponent,
    AirlinesFilterComponent,
    AirportsNearbyFilterComponent,
    StopoverCityFilterComponent,
    PreferencesFilterComponent,
    BookingComponent,
    BookingFareSummaryComponent,
    BookingFlightDetailComponent,
    ServiceRequestsComponent,
    ConfirmPassengerComponent,
    BookingConfirmComponent,
    FlightDetailsBaggageComponent,
    FlightDetailsFareComponent,
    FlightDetailsItineraryComponent,
    FlightDetailsComponent,
    GuestDetailsComponent,
    ReviewFareSummaryComponent,
    PaymentDetailsComponent,
    PreferredAirlineComponent,
    SendItineraryComponent,
    TripInfoComponent,
    VoucherComponent,
    MobileVoucherComponent,
    FareFamiliesFilterComponent,
    DepartureFromFilterComponent,
    ArrivalToFilterComponent,
    FareTypeFilterComponent,
    CabinClassFilterComponent,
    PaymentStatusComponent
  ],
  imports: [
    SharedModule,
    AuthModule,
    CoreModule,
    Ng5SliderModule,
    NouisliderModule,
    SlickCarouselModule,
    MatSliderModule,
    MatCheckboxModule,
    BsDatepickerModule.forRoot(),
    NgxLoadingModule.forRoot({}),
    CollapseModule,
    NgbModule,
    InfiniteScrollModule,
    FlightsRoutingModule,
    NgxSliderModule,
    TabsModule.forRoot(),
    NgProgressModule,
    NgProgressHttpModule,
  ],
  exports: [
    FlightsComponent,
    GuestDetailsComponent
  ]
})
export class FlightsModule { }